/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-fs-test.js
   asset: assets/skon-fs-test.js
   Modulo: Free Shipping Test (FS) + Tracking GA4 integrato
   Versione: 1.5.0 — 10 luglio 2026, 09:26 (Europe/Rome)

   Modifiche v1.5.0 (deploy ATOMICO con skon-identity v2.2.0, nc-experience
   v2.6.0, skon-quiz.js v3.6.0, skon-quiz-priority v2.2):
   - _fallbackClassify: rimossa la regola "quiz completato -> RC", aggiunti
     i cookie skon_customer (RC accertato) e skon_nc_verified (NC accertato).
     Nessun cambiamento al comportamento dell'A/B FS, che resta congelato
     (ab.enabled:false, forceGroup 'A'): il gruppo non dipende da NC/RC.
   - Nessun'altra modifica: runtime invariato rispetto alla 1.4.2 in produzione.

   CHANGELOG
   ─────────
   1.4.2 (21 mag 2026) — FIX LANDING AUDIENCE DA URL
     Bug v1.4.1: il dispatch di skon_fs_visitor_identified leggeva
     fs_landing_audience da sessionStorage 'skon_nc_audience_raw',
     scritto da nc-experience.js. Ma nc-experience.js è caricato async,
     mentre skon-fs-test.js è defer → il bootstrap del modulo gira PRIMA
     che nc-experience abbia scritto in sessionStorage. Risultato:
     fs_landing_audience='' (vuoto) per il 100% dei visitatori.
     Fix: leggiamo il param 'audience' DIRETTAMENTE dall'URL corrente
     (con fallback a sessionStorage per visitatori che hanno navigato
     internamente). Dato che il dispatch è one-time per sessione, basta
     che l'URL della PRIMA pageview abbia il param — che è esattamente
     il caso d'uso che vogliamo misurare (landing con ?audience=new).

   1.4.1 (21 mag 2026) — FIX RACE GTM AL BOOTSTRAP
     Bug v1.4: il guard sessionStorage 'skon_fs_visitor_identified_session'
     veniva armato anche se gtag/dataLayer non erano disponibili al
     momento del bootstrap (race con GTM async). Risultato: l'evento
     veniva perso e nessun retry possibile (guard armato impediva
     re-dispatch a refresh).
     Fix: armiamo il guard SOLO dopo dispatch riuscito. Se gtag/dataLayer
     non sono pronti, retry con polling 100ms fino a 10s.

   1.4 (21 mag 2026) — EVENTO skon_fs_visitor_identified
     Aggiunto dispatch di un nuovo evento GA4 al bootstrap del modulo,
     una sola volta per sessione, per OGNI visitatore (NC, RC, unknown).
     Scopo: misurare ex-post il gap tra traffico landing audience=new
     (4.255 sessions Shopify 5-10 mag) e visitatori effettivamente
     classificati dal modulo (1.339 fs_assigned in GA4 nello stesso
     periodo). L'evento è dispatchato ANCHE quando shouldActivate=false
     o quando visitor_type != 'NC', così possiamo capire dove finisce
     il 68,5% di traffico apparentemente "perso".

     Parametri evento:
     - fs_visitor_type:     'NC' | 'RC' | 'unknown'
     - fs_landing_audience: valore di sessionStorage['skon_nc_audience_raw']
                            (es. 'new' per chi ha avuto ?audience=new
                            nella landing iniziale della sessione)
     - fs_should_activate:  'yes' | 'no'
     - fs_release_mode:     'live' | 'staging' (da CFG.release.mode)
     - più i base params standard (fs_group, fs_threshold)

     Guard one-time: sessionStorage 'skon_fs_visitor_identified_session'.
     Dispatch SEMPRE indipendentemente da shouldActivate (cioè bypassa
     anche la guard 'audience' di _dispatchTracking via path diretto a
     gtag/dataLayer).

   1.3 (21 mag 2026) — LISTENER FILLER-ADDED DIFENSIVO
     Reso il listener 'skon-fs:filler-added' tollerante a ENTRAMBE le
     convenzioni di naming del payload:
     - snake_case (product_handle, variant_id, price_cents,
       subtotal_before_cents, visitor_type) — convenzione standard,
       emessa da skon-fs-suggestions.js v1.1+
     - camelCase (productHandle, variantId, priceCents) — convenzione
       legacy di skon-fs-suggestions.js v1.0
     Fallback intelligente: se il campo snake_case è assente o vuoto,
     il listener prova la versione camelCase prima di defaultare.
     Inoltre il listener legge SkonFS.id.getVisitorType() come fallback
     se visitor_type non è nel detail (era una mancanza del payload v1.0).

   1.2 (21 mag 2026) — TRACKING INTEGRATO + FIX EVENTI PERSI
     PROBLEMA RILEVATO: in v1.1, l'evento 'skon-fs:assigned' del bootstrap
     non veniva mai ricevuto dal listener in skon-fs-tracking.js, anche con
     listener registrato sincronicamente allo script load. Diagnosi via MCP
     su skoncosmetics.com ha dimostrato che SkonFS.tracking non viene
     esposto da _ensureReady() perché il listener non riceve mai l'evento
     del bootstrap (mentre dispatch manuali post-load funzionano). Causa
     esatta non identificata definitivamente, ma plausibilmente legata
     all'ordine di parse degli script defer e al setTimeout(0) di dispatch.

     SOLUZIONE: spostata TUTTA la logica di tracking GA4 dentro questo file.
     I 4 eventi emessi DA questo file (assigned, threshold-reached,
     discount-applied, checkout-initiated) chiamano direttamente _dispatch
     in-process senza passare per document.dispatchEvent. L'unico evento
     che rimane via DOM listener è 'skon-fs:filler-added', emesso dal modulo
     esterno skon-fs-suggestions.js.

     Vantaggi:
     - Zero race condition cross-file: la chiamata _dispatch è sincrona
       dentro lo stesso closure di getGroup()
     - Niente più dipendenza dall'ordine di parse degli script
     - Niente più event bus DOM da debuggare
     - Una sola fonte di verità per il tracking

     COMPATIBILITY:
     - skon-fs-tracking.js v1.2 (file separato) viene svuotato e mantenuto
       solo come stub per non rompere il caricamento da theme.liquid.
     - SkonFS.tracking.dispatch() rimane esposta per consumer esterni.
     - I 5 eventi DOM (skon-fs:*) continuano comunque a essere dispatchati
       da emit() per eventuali ascoltatori esterni; il tracking GA4 però
       NON dipende più da quei dispatch.

     Inoltre v1.2 include i fix di v1.1:
     - Retry queue (gtag/dataLayer non disponibili → coda fino a 10s)
     - Dedup signature (no doppi fire entro 5s)
     - Cap memoria (max 50 eventi in coda)
     - Consent Mode v2 (sempre dispatcha, GA4 gestisce)

   1.1 (21 mag 2026):
     - Aggiunto parametro URL ?skon_fs_force_split=1 per riattivare lo
       split A/B con randomizzazione naturale anche quando abCfg.enabled
       è false. Utile per QA via MCP.

   1.0 (mag 2026):
     - Release iniziale del modulo Free Shipping Test.

   COSA FA QUESTO MODULO
   ─────────────────────
   Conduce un A/B test su 50% dei NUOVI CLIENTI (NC) per misurare l'impatto
   di una soglia di free shipping ridotta da 49€ a 29€.

   Visitatore arriva sul sito → identificato come NC/RC tramite SkonFS.id ─┐
                                                                          ↓
   Se NC → assegnato deterministicamente a gruppo A (49€) o B (29€)      │
   Se RC → modulo non interviene, esperienza nativa Shopify              │
                                                                          ↓
   Cart drawer aperto → progress bar custom con la soglia del gruppo      │
   Gruppo B → auto-apply silenzioso del coupon (CFG.discountCode)        │
   Tracking GA4 ad ogni evento rilevante                                  │
                                                                          ↓
   Toggle on/off da skon-fs-config.js senza side effect                   ┘

   FILOSOFIA ARCHITETTURALE
   ────────────────────────
   Questo modulo è il PRIMO modulo della futura "NC Experience modulare".
   È stato progettato con tre vincoli:

   1) IDENTIFICATION VIA WRAPPER FUNCTION
      Il modulo non hardcoda la logica NC/RC. Usa SkonFS.id.getVisitorType()
      che internamente delega a _classify() di nc-experience.js (se presente)
      o esegue una classificazione locale equivalente. Quando in futuro
      verrà costruito SkonID globale, basterà sostituire la delegation
      senza toccare il modulo.

   2) CONFIG ESTERNA
      Tutti i parametri editabili vivono in skon-fs-config.js.
      Il modulo legge da window.SKON_FS_CONFIG e non ha valori hardcodati.

   3) NO SIDE EFFECT QUANDO SPENTO
      Se SKON_FS_CONFIG.enabled = false, il modulo non si registra a nulla,
      non aggiunge listener, non modifica DOM. L'esperienza è esattamente
      quella nativa del tema.

   DEPLOYMENT: caricare DOPO skon-fs-config.js in theme.liquid (defer).
══════════════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ──────────────────────────────────────────────────────────────────
  // GUARD: modulo spento → exit immediato, zero side effect
  // ──────────────────────────────────────────────────────────────────

  const CFG = window.SKON_FS_CONFIG;
  if (!CFG || !CFG.enabled) return;


  // ──────────────────────────────────────────────────────────────────
  // UTILITIES interne (non globali)
  // ──────────────────────────────────────────────────────────────────

  function _log() {
    if (!CFG.debug || !CFG.debug.verbose) return;
    const args = Array.prototype.slice.call(arguments);
    args.unshift('[skon-fs]');
    console.info.apply(console, args);
  }

  function _getCookie(name) {
    const m = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function _setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 864e5));
    document.cookie = name + '=' + encodeURIComponent(value) +
                      ';expires=' + d.toUTCString() +
                      ';path=/;SameSite=Lax';
  }

  function _ss(key, val) {
    try {
      if (typeof val === 'undefined') return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function _getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function _formatEUR(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function _interpolate(template, values) {
    return template.replace(/\{\{(\w+)\}\}/g, function(_, key) {
      return key in values ? values[key] : '';
    });
  }


  // ══════════════════════════════════════════════════════════════════
  // SkonFS — namespace pubblico
  // ══════════════════════════════════════════════════════════════════

  const SkonFS = {};


  // ══════════════════════════════════════════════════════════════════
  // TRACKING GA4 INTEGRATO (ex skon-fs-tracking.js, integrato in v1.2)
  // ══════════════════════════════════════════════════════════════════
  //
  // ARCHITETTURA:
  // - I 4 eventi emessi DA QUESTO FILE (assigned, threshold-reached,
  //   discount-applied, checkout-initiated) chiamano direttamente
  //   _dispatchTracking() in-process, senza document.dispatchEvent.
  // - L'evento 'skon-fs:filler-added' (emesso da skon-fs-suggestions.js)
  //   è gestito via document.addEventListener perché esterno a questo file.
  // - Tutti e 5 i CustomEvent DOM continuano comunque a essere dispatchati
  //   da SkonFS.bus.emit() per eventuali ascoltatori esterni; il tracking
  //   GA4 però NON dipende più da quei dispatch.
  //
  // CONSENT MODE V2 (Opzione B):
  // Gli eventi sono SEMPRE dispatchati a gtag/dataLayer. Google lato GA4
  // gestisce internamente il drop o il modeling in base allo stato consent.
  // Coerente con la configurazione GTM/Consent Mode attualmente attiva.

  const TRK_FLUSH_INTERVAL_MS = 100;    // polling per riprovare il dispatch
  const TRK_FLUSH_MAX_AGE_MS  = 10000;  // eventi più vecchi di 10s scartati
  const TRK_DEDUP_WINDOW_MS   = 5000;   // dedup di eventi uguali entro 5s
  const TRK_QUEUE_CAP         = 50;     // cap massimo coda

  const _trkPendingEvents = [];          // [{eventName, params, queuedAt, signature}]
  const _trkRecentSignatures = new Map(); // signature → timestamp ultimo dispatch
  let   _trkFlushTimer = null;

  function _trkNow() {
    return (typeof performance !== 'undefined' && performance.now)
      ? performance.now() : Date.now();
  }

  function _trkHasGtag() {
    return typeof window.gtag === 'function';
  }

  function _trkHasDataLayer() {
    return window.dataLayer && Array.isArray(window.dataLayer);
  }

  function _trkLog() {
    if (!CFG.debug || !CFG.debug.verbose) return;
    const args = Array.prototype.slice.call(arguments);
    args.unshift('[skon-fs:tracking]');
    console.info.apply(console, args);
  }

  /**
   * Tenta il dispatch immediato. Prova gtag (canale GA4 principale che
   * pusha già internamente su dataLayer); se gtag non disponibile, fallback
   * a dataLayer.push diretto. NON fa entrambi per evitare doppi push.
   * Ritorna true se almeno uno ha avuto successo.
   */
  function _trkTryDeliver(eventName, params) {
    if (_trkHasGtag()) {
      try {
        window.gtag('event', eventName, params);
        _trkLog('gtag dispatched:', eventName, params);
        return true;
      } catch (e) {
        _trkLog('gtag call threw, falling back to dataLayer:', e && e.message);
      }
    }
    if (_trkHasDataLayer()) {
      try {
        window.dataLayer.push(Object.assign({ event: eventName }, params));
        _trkLog('dataLayer pushed:', eventName, params);
        return true;
      } catch (e) {
        _trkLog('dataLayer push threw:', e && e.message);
      }
    }
    return false;
  }

  function _trkSignatureOf(eventName, params) {
    try {
      return eventName + '|' + JSON.stringify(params || {});
    } catch (e) {
      return eventName + '|<unstringifiable>';
    }
  }

  function _trkEnqueue(eventName, params) {
    const now = _trkNow();
    const signature = _trkSignatureOf(eventName, params);

    // DEDUP
    const lastSeen = _trkRecentSignatures.get(signature);
    if (lastSeen && (now - lastSeen) < TRK_DEDUP_WINDOW_MS) {
      _trkLog('dedup skip:', eventName, '(seen', Math.round(now - lastSeen) + 'ms ago)');
      return;
    }
    _trkRecentSignatures.set(signature, now);

    // Cap memoria
    if (_trkPendingEvents.length >= TRK_QUEUE_CAP) {
      const dropped = _trkPendingEvents.shift();
      _trkLog('queue cap reached, dropped oldest:', dropped && dropped.eventName);
    }

    _trkPendingEvents.push({
      eventName: eventName,
      params: params,
      queuedAt: now,
      signature: signature
    });
    _trkLog('queued (will retry):', eventName, params);

    if (!_trkFlushTimer) {
      _trkFlushTimer = setInterval(_trkFlushPending, TRK_FLUSH_INTERVAL_MS);
    }
  }

  function _trkFlushPending() {
    const now = _trkNow();
    const stillPending = [];

    for (let i = 0; i < _trkPendingEvents.length; i++) {
      const ev = _trkPendingEvents[i];
      if (_trkTryDeliver(ev.eventName, ev.params)) {
        _trkLog('flushed queued event:', ev.eventName,
                '(was queued for ' + Math.round(now - ev.queuedAt) + 'ms)');
        continue;
      }
      if (now - ev.queuedAt > TRK_FLUSH_MAX_AGE_MS) {
        _trkLog('event expired, giving up:', ev.eventName);
        continue;
      }
      stillPending.push(ev);
    }

    _trkPendingEvents.length = 0;
    for (let i = 0; i < stillPending.length; i++) _trkPendingEvents.push(stillPending[i]);

    // Cleanup dedup map
    _trkRecentSignatures.forEach(function(ts, sig) {
      if (now - ts > TRK_DEDUP_WINDOW_MS) _trkRecentSignatures.delete(sig);
    });

    if (_trkPendingEvents.length === 0 && _trkFlushTimer) {
      clearInterval(_trkFlushTimer);
      _trkFlushTimer = null;
      _trkLog('queue empty, flush timer cleared');
    }
  }

  /**
   * Costruisce i parametri base comuni a tutti gli eventi GA4.
   * Chiamata dentro _dispatchTracking, quindi dopo che SkonFS.ab è pronto.
   *
   * @param {Object} [overrides] - opzionale: { group, threshold } per
   *   evitare ri-chiamate a SkonFS.ab.getGroup() quando il chiamante
   *   conosce già il gruppo (es. ramo "nuova assegnazione" dentro getGroup,
   *   che chiamerebbe getGroup ricorsivamente). Se overrides.group è 'B'
   *   ma overrides.threshold è omesso, la threshold viene calcolata.
   */
  function _trkBaseParams(overrides) {
    const o = overrides || {};
    const group = o.group || SkonFS.ab.getGroup();
    const threshold = (typeof o.threshold === 'number')
      ? o.threshold
      : (group === 'B' ? CFG.thresholds.groupB : CFG.thresholds.groupA);
    const releaseMode = (CFG.release && CFG.release.mode) || 'staging';
    return {
      fs_group:        group,
      fs_threshold:    String(threshold / 100),
      fs_release_mode: releaseMode,
    };
  }

  /**
   * Punto di ingresso pubblico per dispatch evento GA4.
   * Prova consegna immediata; se fallisce, mette in coda con dedup.
   *
   * Guard: rispetta CFG.ga4.enabled. Se false, no-op silenzioso.
   * Guard: rispetta SkonFS.id.shouldActivate(). Se false, no-op silenzioso.
   *   Replica il comportamento di skon-fs-tracking.js v1.0 che aveva
   *   il check `if (!SkonFS.id.shouldActivate()) return;` prima di
   *   esporre l'API e registrare i listener.
   *
   * @param {string} eventName
   * @param {Object} [customParams]
   * @param {Object} [baseOverrides] - { group, threshold } opzionale,
   *   per evitare ri-chiamate a getGroup() in contesti ricorsivi.
   */
  function _dispatchTracking(eventName, customParams, baseOverrides) {
    // Guard 1: tracking spento globalmente in config
    if (!CFG.ga4 || !CFG.ga4.enabled) return;

    // Guard 2: visitatore fuori target audience
    if (!SkonFS.id.shouldActivate()) return;

    const params = Object.assign({}, _trkBaseParams(baseOverrides), customParams || {});
    const signature = _trkSignatureOf(eventName, params);
    const now = _trkNow();

    // DEDUP anche sui dispatch immediati
    const lastSeen = _trkRecentSignatures.get(signature);
    if (lastSeen && (now - lastSeen) < TRK_DEDUP_WINDOW_MS) {
      _trkLog('dedup skip (immediate):', eventName, '(seen', Math.round(now - lastSeen) + 'ms ago)');
      return;
    }

    // Tentativo immediato
    if (_trkTryDeliver(eventName, params)) {
      _trkRecentSignatures.set(signature, now);
      return;
    }

    // Né gtag né dataLayer disponibili → coda
    _trkLog('NO GA4/GTM yet, queueing:', eventName);
    _trkEnqueue(eventName, params);
  }


  // ──────────────────────────────────────────────────────────────────
  // SkonFS.id — Identification engine (ponte verso futura SkonID)
  // ──────────────────────────────────────────────────────────────────
  //
  // Questa è la funzione "ponte". Internamente delega:
  //   1. Prima a _classify() di nc-experience.js se ha già scritto in
  //      sessionStorage skon_visitor_type (è il loro pattern attuale)
  //   2. Poi a logica locale standalone equivalente (5 livelli cascata)
  //
  // Quando costruiremo SkonID globale, questa funzione diventerà:
  //   getVisitorType: () => window.SkonID.getVisitor().type
  // E nient'altro nel modulo cambierà.

  SkonFS.id = {

    /**
     * Ritorna 'NC' | 'RC' | 'unknown'
     */
    getVisitorType: function() {

      // (a) Fonte di verità unica: window.SkonID (asset skon-identity.js).
      //     SkonID incorpora la stessa cascata che stava qui sotto + la
      //     lettura prioritaria di skon_visitor_type. Quando è presente,
      //     deleghiamo interamente a lui (obiettivo SkonID globale già
      //     preannunciato nei commenti di questo modulo).
      if (window.SkonID && typeof window.SkonID.getVisitorType === 'function') {
        const t = window.SkonID.getVisitorType();
        _log('id source: SkonID =', t);
        return t;
      }

      // (b) FALLBACK standalone — solo se skon-identity.js non è caricato su
      //     questa pagina. Replica la cascata di SkonID per non lasciare il
      //     modulo cieco. Non dovrebbe mai servire (SkonID è in theme.liquid).

      // Fonte primaria: sessionStorage eventualmente già scritto
      const fromNcExp = _ss('skon_visitor_type');
      if (fromNcExp === 'NC' || fromNcExp === 'RC') {
        _log('id source: sessionStorage fallback =', fromNcExp);
        return fromNcExp;
      }

      // Livello 1 — RC verificato (già confermato dal worker in passato)
      if (_ss('skon_rc_verified') === '1') {
        _ss('skon_visitor_type', 'RC');
        return 'RC';
      }

      // Livello 2 — Sessione Shopify autenticata o quiz completato
      if (_getCookie('_shopify_customer_token')) {
        _ss('skon_visitor_type', 'RC');
        return 'RC';
      }
      /* v1.5.0 — RIMOSSA la regola "quiz completato → RC". Era la terza copia
         della stessa cascata (skon-identity.js, nc-experience.js, questo file):
         il 9 lug 2026 correggerne una sola avrebbe lasciato le altre a mentire.
         Un lead che ha compilato il quiz NON ha comprato.
         Sostituita dal cookie `skon_customer`, scritto da SkonID.markCustomer()
         solo dopo verifica dell'email sugli ordini Shopify. */
      if (_getCookie('skon_customer') === '1') {
        _ss('skon_visitor_type', 'RC');
        return 'RC';
      }
      /* NC accertato (SkonID.markNonCustomer): email cercata negli ordini e non
         trovata. Dopo i livelli RC: un "no" di ieri non scavalca un "sì" di oggi. */
      if (_getCookie('skon_nc_verified') === '1') {
        _ss('skon_visitor_type', 'NC');
        return 'NC';
      }

      // Livello 3 — Parametro URL audience
      const aud = _getParam('audience');
      if (aud === 'new') {
        _ss('skon_nc_audience_raw', 'new');
        _ss('skon_visitor_type',    'NC');
        return 'NC';
      }
      if (aud === 'exi') {
        _ss('skon_nc_audience_raw', 'exi');
        _ss('skon_visitor_type',    'RC');
        return 'RC';
      }

      // Livello 4 — Autodichiarazione precedente
      const declared = _ss('skon_nc_declared');
      if (declared === 'returning') { _ss('skon_visitor_type', 'RC'); return 'RC'; }
      if (declared === 'new')       { _ss('skon_visitor_type', 'NC'); return 'NC'; }

      // Default
      return 'unknown';
    },

    /**
     * True se il modulo deve essere attivo per questo visitatore.
     * Combina release mode + audience target + debug override.
     */
    shouldActivate: function() {
      const releaseMode  = (CFG.release && CFG.release.mode) || 'staging';
      const unlockParam  = (CFG.release && CFG.release.unlockParam) || 'skon_fs_test';

      // Debug override esplicito: ?skon_fs_debug=1 attiva sempre, indipendente da release mode
      if (CFG.debug && CFG.debug.forceShowOnDebugParam &&
          _getParam('skon_fs_debug') === '1') {
        _log('id: forced active via debug param');
        return true;
      }

      // RELEASE MODE = staging
      // → Il modulo si attiva SOLO se l'URL contiene ?skon_fs_test=1
      //   OPPURE se l'unlock è già stato persistito in sessione (così la
      //   navigazione interna non spegne il modulo dopo l'unlock iniziale).
      if (releaseMode === 'staging') {
        // Step 1 — se l'unlock è già persistito, attivo immediatamente
        if (_ss('skon_fs_unlocked') === '1') {
          _log('id: staging mode, unlock already persisted in session');
          return true;
        }
        // Step 2 — se l'URL ha il param, persisto l'unlock e attivo
        const unlockValue = _getParam(unlockParam);
        if (unlockValue === '1') {
          _ss('skon_fs_unlocked', '1');
          _log('id: staging mode unlocked via URL param');
          return true;
        }
        // Step 3 — niente unlock né in URL né in session → spento
        _log('id: staging mode, no unlock → exit');
        return false;
      }

      // RELEASE MODE = live
      // → Il modulo si attiva SEMPRE (per tutti i visitatori).
      //   L'esperienza Skön (progress bar + widget cross-sell + riga
      //   Spedizione) è ora la NORMA per il drawer, non un'eccezione.
      //   I comportamenti differenziati per audience (split A/B, toast
      //   onboarding "primo ordine", banner promo gruppo B) sono gestiti
      //   downstream in `ab.getGroup()` e nelle componenti UI.
      return true;
    },
  };


  // ──────────────────────────────────────────────────────────────────
  // SkonFS.ab — A/B group assignment
  // ──────────────────────────────────────────────────────────────────

  SkonFS.ab = {

    /**
     * Ritorna 'A' o 'B'.
     *
     * NUOVO COMPORTAMENTO (giugno 2026 — esperienza universale):
     * - Solo i visitatori NC entrano nello split A/B 50/50 con cookie persistente.
     * - RC e unknown ricevono SEMPRE il gruppo A (= soglia €49 default tema)
     *   senza scrivere cookie. Questo li tiene su un'esperienza identica
     *   a quella standard del tema, ma servita comunque dal modulo
     *   (così abbiamo coerenza UI e siamo pronti a dare loro varianti
     *   dedicate in futuro).
     * - Override `?skon_fs_force=A|B` continua a funzionare per qualsiasi
     *   visitor type (utile per testing).
     */
    getGroup: function() {
      const abCfg = CFG.ab;

      // Debug override: ?skon_fs_force=A o ?skon_fs_force=B
      // Quando viene forzato via URL, sovrascriviamo anche il cookie
      // così la persistenza in sessioni di test è coerente.
      const forced = _getParam('skon_fs_force');
      if (forced === 'A' || forced === 'B') {
        _log('ab: forced group via URL =', forced, '(cookie overwritten)');
        _setCookie(abCfg.cookieName, forced, abCfg.cookieDays);
        return forced;
      }

      // RC o unknown → sempre gruppo A, niente cookie scritto
      // (li teniamo su esperienza standard tema; lo split A/B è riservato
      // ai NC perché è lì che vogliamo misurare l'effetto della soglia €29)
      const visitor = SkonFS.id.getVisitorType();
      if (visitor !== 'NC') {
        _log('ab: visitor is', visitor, '→ default group A (no cookie)');
        return 'A';
      }

      // Da qui in poi: visitor === NC.

      // SKÖN custom (21 maggio 2026) — Override URL per riattivare lo split
      // anche quando abCfg.enabled = false. Utile per QA via MCP e verifica
      // del flusso reale di assegnazione + dispatch evento skon-fs:assigned
      // senza dover toccare skon-fs-config.js.
      //
      // Il flag è persistito in sessionStorage così la navigazione interna
      // della sessione di test mantiene lo split attivo anche su URL
      // successive che non hanno il parametro.
      //
      // Uso: ?skon_fs_force_split=1 sulla prima URL della sessione QA.
      const forceSplitParam = _getParam('skon_fs_force_split');
      if (forceSplitParam === '1') _ss('skon_fs_force_split', '1');
      const forceSplit = (_ss('skon_fs_force_split') === '1');

      // Modulo con split disabilitato → tutti gli NC nel gruppo forzato
      // (a meno che l'override URL force_split non sia attivo)
      if (!abCfg.enabled && !forceSplit) {
        return abCfg.forceGroup === 'B' ? 'B' : 'A';
      }
      if (forceSplit) {
        _log('ab: split forced active via ?skon_fs_force_split=1 (or session flag)');
      }

      // Esistente in cookie?
      const existing = _getCookie(abCfg.cookieName);
      if (existing === 'A' || existing === 'B') {
        _log('ab: existing assignment =', existing);
        return existing;
      }

      // Nuova assegnazione 50/50 (solo NC)
      const group = Math.random() < 0.5 ? 'A' : 'B';
      _setCookie(abCfg.cookieName, group, abCfg.cookieDays);
      _log('ab: new NC assignment =', group);

      // v1.2: tracking GA4 chiamato DIRETTAMENTE in-process (no race).
      // Il CustomEvent DOM viene comunque dispatchato per eventuali
      // ascoltatori esterni (debug, future estensioni), ma il tracking
      // GA4 non dipende più da quel canale.
      _ss('skon_fs_just_assigned', '1');

      // Chiamata diretta in-process al tracking.
      // Passiamo group esplicitamente come override per evitare che
      // _trkBaseParams ri-chiami SkonFS.ab.getGroup() ricorsivamente
      // (qui siamo dentro getGroup stesso, e benché il cookie sia già
      // scritto e la chiamata interna si fermerebbe al ramo "existing in
      // cookie", evitare la ri-chiamata è più pulito e robusto).
      const thresholdCents = (group === 'B' ? CFG.thresholds.groupB : CFG.thresholds.groupA);
      _dispatchTracking(CFG.ga4.events.assigned, {
        fs_visitor_type: 'NC',
      }, { group: group, threshold: thresholdCents });

      // DOM dispatch (compatibilità per ascoltatori esterni)
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('skon-fs:assigned', {
          detail: {
            group: group,
            threshold_cents: group === 'B' ? CFG.thresholds.groupB : CFG.thresholds.groupA,
            visitor_type: 'NC'
          }
        }));
      }, 0);

      return group;
    },

    /**
     * Soglia free shipping per il gruppo del visitatore corrente.
     * In centesimi.
     */
    getThreshold: function() {
      const group = this.getGroup();
      return group === 'B' ? CFG.thresholds.groupB : CFG.thresholds.groupA;
    },
  };


  // ──────────────────────────────────────────────────────────────────
  // SkonFS.bus — Event bus interno
  // ──────────────────────────────────────────────────────────────────
  //
  // SKÖN custom (maggio 2026) — REFACTOR ARCHITETTURALE.
  //
  // Tutti i moduli UI (progress bar, widget cross-sell, eventuali
  // moduli futuri) si agganciano a UN SOLO evento sintetico:
  //
  //   'skon-fs:state-changed'
  //
  // emesso da SkonFS.cart.refresh() ogni volta che lo stato del
  // carrello viene refreshato. Il payload (vedi _buildState) contiene
  // TUTTI i dati di cui i moduli hanno bisogno per renderizzare:
  // subtotal, threshold, achieved, gap, mode (per il widget),
  // isBelowHalfway, group, visitor type, ecc.
  //
  // Razionale: prima del refactor, ogni modulo si iscriveva
  // autonomamente ai 4 cart events nativi del tema, e c'erano
  // sovrapposizioni di mount = flicker visibile. Adesso il modulo
  // cart è la SINGLE SOURCE OF TRUTH per i trigger e i dati.
  // Niente più listener cart events nei singoli moduli.
  //
  // API pubblica:
  //   SkonFS.bus.on(eventName, handler)     → si iscrive
  //   SkonFS.bus.off(eventName, handler)    → disiscrive
  //   SkonFS.bus.emit(eventName, payload)   → emette
  //
  // Implementato sopra document.dispatchEvent + addEventListener
  // perché DOM events sono già nativamente robusti (no memory leaks
  // su detach pagina, gestione errori isolata per handler, etc.) e
  // permettono debug via Chrome DevTools "Event Listeners" panel.
  // ──────────────────────────────────────────────────────────────────

  SkonFS.bus = {
    on: function(eventName, handler) {
      document.addEventListener(eventName, handler);
    },
    off: function(eventName, handler) {
      document.removeEventListener(eventName, handler);
    },
    emit: function(eventName, payload) {
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload || {} }));
    },
  };


  // ──────────────────────────────────────────────────────────────────
  // SkonFS.cart — Lettura stato carrello + apply discount
  // ──────────────────────────────────────────────────────────────────

  SkonFS.cart = {

    /** Cache locale dell'ultimo subtotal noto (in centesimi) */
    _lastSubtotal: null,

    /**
     * Cache locale dell'ultimo cart object completo restituito da /cart.js.
     * Esposta per consumatori esterni (es. skon-fs-suggestions.js) che
     * devono leggere total_discount, cart_level_discount_applications,
     * o altri campi senza dover fare un fetch indipendente.
     * Aggiornata insieme a _lastSubtotal in refresh().
     */
    _lastCart: null,

    /** Promise in volo per evitare fetch duplicati simultanei */
    _inflightFetch: null,

    /** Timer del debounce di scheduleRefresh (vedi sotto) */
    _refreshTimer: null,

    /**
     * Subtotal corrente sincrono. Usa la cache se disponibile.
     * Se la cache è vuota, scatena un refresh asincrono in background
     * (che richiamerà mountProgressBar al termine).
     */
    getSubtotal: function() {
      if (this._lastSubtotal === null) {
        // Prima volta: scatena refresh ma ritorna null per ora.
        // Quando il refresh termina, mountProgressBar verrà richiamato.
        this.refresh();
      }
      return this._lastSubtotal;
    },

    /**
     * True quando il cart HTML renderizzato da Liquid contiene almeno
     * un prodotto con tag Shopify "KitFreeShip".
     *
     * /cart.js non espone i product.tags, quindi il bridge corretto è
     * server-side: cart-summary.liquid calcola il tag e lo pubblica come
     * data attribute. Qui lo leggiamo per allineare progress bar, drawer
     * e widget allo stesso stato free-shipping del checkout function.
     */
    hasKitFreeShipUnlock: function() {
      return !!document.querySelector('[data-skon-kit-free-ship="1"]');
    },

    /**
     * SKÖN custom (maggio 2026) — Schedule refresh con debounce.
     *
     * Il modulo è iscritto a 4 cart events distinti ('cart:update',
     * 'cart:add', 'discount:update', 'cart-update') per intercettare
     * tutte le convenzioni che i temi Shopify possono dispatchare.
     * Inoltre c'è un MutationObserver come safety-net che ripopola i
     * placeholder se il tema li svuota.
     *
     * PROBLEMA: per UN SINGOLO cart change, il tema può dispatchare
     * più di un evento (es. sia 'cart:update' sia 'cart-update'),
     * E in più svuota il placeholder e lo MutationObserver lo rileva.
     * Risultato: 2-4 chiamate a refresh() in <200ms = 2-4 cicli di
     * mount = flicker visibile delle card.
     *
     * SOLUZIONE: tutti i trigger reattivi (cart events e
     * MutationObserver) chiamano scheduleRefresh() invece di refresh().
     * scheduleRefresh accumula i trigger entro una finestra di 100ms
     * e fa partire UN solo refresh() al termine. Le chiamate "una
     * tantum" (boot, dialog:open) usano refresh() direttamente.
     *
     * 100ms è scelto come trade-off:
     *   - abbastanza lungo per coalizzare tutti i trigger di un cart
     *     change (tipicamente entro 50ms)
     *   - abbastanza breve da non ritardare visibilmente il feedback
     *     UI (l'utente non percepisce <150ms come "in ritardo")
     */
    scheduleRefresh: function() {
      if (this._refreshTimer) {
        clearTimeout(this._refreshTimer);
      }
      this._refreshTimer = setTimeout(function() {
        SkonFS.cart._refreshTimer = null;
        SkonFS.cart.refresh();
      }, 100);
    },

    /**
     * SKÖN custom (maggio 2026) — Costruisce il payload di stato
     * completo che viene poi distribuito ai moduli UI via
     * 'skon-fs:state-changed'.
     *
     * Single source of truth: tutti i dati di cui i moduli hanno
     * bisogno per renderizzare sono qui. I moduli ricevono il
     * payload e mutano i loro nodi DOM senza fare calcoli paralleli.
     * Razionale: prima del refactor, ogni modulo riapplicava la
     * stessa logica (calcolo achieved, mode dispatcher, isBelowHalfway,
     * etc.) creando rischi di disallineamento (es. widget che si
     * renderizza con mode "free-shipping" mentre la barra è già
     * "achieved" perché letti in momenti diversi).
     *
     * Il `mode` per il widget è calcolato qui per garantire che
     * progress bar e widget vedano lo STESSO mode allo stesso
     * istante.
     */
    _buildState: function() {
      const subtotal     = this._lastSubtotal || 0;
      const threshold    = SkonFS.ab.getThreshold();
      const kitFreeShipUnlocked = this.hasKitFreeShipUnlock();
      const thresholdGap = Math.max(0, threshold - subtotal);
      const achieved     = kitFreeShipUnlocked || thresholdGap === 0;
      const gap          = achieved ? 0 : thresholdGap;
      const pctLinear    = achieved ? 100 : (threshold > 0
        ? Math.min(100, (subtotal / threshold) * 100)
        : 0);
      const group        = SkonFS.ab.getGroup();
      const visitor      = SkonFS.id.getVisitorType();

      const gapTriggerPct = (CFG.widgetModes && CFG.widgetModes.gapTriggerPct) || 0.50;
      const isBelowHalfway = !achieved && (pctLinear < gapTriggerPct * 100);

      // SKÖN custom (maggio 2026) — Sticky track visibility.
      //
      // Una volta che la track della progress bar è apparsa nella
      // sessione (perché il subtotal ha superato il 50% lineare della
      // soglia, oppure perché è stata raggiunta), DEVE rimanere visibile
      // anche se il subtotal scende successivamente sotto-50% (es. il
      // visitatore applica un coupon order-level che riduce il
      // subtotal post-sconto, oppure rimuove un prodotto).
      //
      // Senza stickyness, la track scomparirebbe creando un effetto
      // "salto" dell'UI, e il messaggio sopra tornerebbe alla variante
      // valoriale (CO₂) invece di mantenere il riferimento concreto
      // a "quanto manca per la spedizione gratis", che è quello che
      // il visitatore si aspetta una volta che ha visto la barra.
      //
      // Il flag `skon_fs_progress_unlocked_session` viene settato in
      // _updateProgressShell la prima volta che la track diventa
      // visibile (vedi anche logica firstTimeUnlock per l'animazione
      // 0%→target). Qui lo leggiamo come stato persistente di sessione.
      const wasUnlocked = (function() {
        try { return sessionStorage.getItem('skon_fs_progress_unlocked_session') === '1'; }
        catch (e) { return false; }
      })();
      const trackVisible = achieved || (pctLinear >= gapTriggerPct * 100) || wasUnlocked;

      // Mode dispatcher per il widget cross-sell (era duplicato
      // dentro skon-fs-suggestions, ora vive qui per garantire
      // single source of truth).
      let widgetMode;
      if (subtotal === 0) {
        widgetMode = 'bestseller';
      } else if (achieved) {
        widgetMode = 'related';
      } else if (gap > threshold * gapTriggerPct) {
        widgetMode = 'related';
      } else {
        widgetMode = 'freeshipping';
      }

      return {
        subtotal_cents:   subtotal,
        threshold_cents:  threshold,
        gap_cents:        gap,
        achieved:         achieved,
        pct_linear:       pctLinear,
        is_below_halfway: isBelowHalfway,
        track_visible:    trackVisible,
        group:            group,
        visitor_type:     visitor,
        widget_mode:      widgetMode,
        kit_free_ship_unlocked: kitFreeShipUnlocked,
        cart:             this._lastCart,
      };
    },

    /**
     * Fetch /cart.js, aggiorna la cache, e re-monta UI se subtotal cambia.
     * È idempotente: chiamate concorrenti riusano la stessa promise.
     */
    refresh: async function() {
      if (this._inflightFetch) return this._inflightFetch;

      this._inflightFetch = (async function() {
        try {
          const res = await fetch('/cart.js?_t=' + Date.now(), {
            credentials: 'same-origin',
          });
          const data = await res.json();
          // Shopify ritorna total_price in cents (subtotal carrello senza spedizione,
          // dopo eventuali discount). È il valore corretto per la progress bar
          // free-shipping perché Shopify confronta proprio il "subtotal" col minimum.
          const newSubtotal = data.total_price || 0;
          const changed = (SkonFS.cart._lastSubtotal !== newSubtotal);
          SkonFS.cart._lastSubtotal = newSubtotal;
          SkonFS.cart._lastCart = data;

          // SKÖN custom (maggio 2026) — REFACTOR: emit single event.
          //
          // Prima del refactor, qui chiamavamo direttamente
          // mountProgressBarFast() e mountWidgetFast() (e anche dal
          // MutationObserver di safety-net, e dai listener cart events
          // del modulo widget): risultato 2-4 mount sovrapposti per
          // un singolo cart change = flicker.
          //
          // Adesso emettiamo UN SOLO evento sintetico 'skon-fs:state-changed'
          // con il payload completo. I moduli UI sono ascoltatori passivi
          // di questo evento e mutano i loro nodi DOM (senza distruggerli
          // né ricrearli). Niente più innerHTML su cart change, niente
          // più flicker.
          //
          // Emettiamo SEMPRE (anche se subtotal non è cambiato) perché
          // altri stati possono comunque essere variati: gli sconti
          // possono cambiare a parità di subtotal, il group via override
          // URL, il visitor_type post-login, ecc. I moduli UI ottimizzano
          // internamente: se nulla cambia per loro, no-op.
          const state = SkonFS.cart._buildState();
          SkonFS.bus.emit('skon-fs:state-changed', state);

          _log('cart: refreshed, subtotal =', newSubtotal, 'changed =', changed);
          return newSubtotal;
        } catch (e) {
          _log('cart: refresh failed', e);
          return null;
        } finally {
          SkonFS.cart._inflightFetch = null;
        }
      })();

      return this._inflightFetch;
    },

    /**
     * Applica un discount code al carrello (silenzioso, senza UI).
     *
     * STRATEGIA (γ): tentativo fetch silenzioso, fallback al redirect.
     *
     * Step 1 — fetch a /discount/CODE: Shopify dovrebbe settare il cookie
     *          discount lato server. Funziona nella maggior parte dei browser
     *          ma con qualche fragilità (CORS, redirect handling).
     *
     * Step 2 — verifica via /cart.js dopo il fetch: il discount appare
     *          in cart.discount_codes con applicable:true?
     *
     * Step 3 — se NON applicato, fallback: redirect a /discount/CODE?redirect=URL
     *          al prossimo click utente (NON immediato per non spaccare l'UX).
     *          Il redirect è SHOPIFY-NATIVE, sempre funziona.
     */
    applyDiscount: async function(code) {
      if (!code) return;

      // Evita riapplicazioni multiple nella stessa sessione
      const flagKey = 'skon_fs_applied_' + code;
      if (_ss(flagKey) === '1') {
        _log('cart: discount', code, 'already applied this session');
        return;
      }

      _log('cart: applying discount', code, '(silent fetch)');

      let appliedSilently = false;

      // STEP 1 — fetch silenzioso
      try {
        await fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'manual',
        }).catch(function() {
          // 'manual' su fetch può lanciare in alcuni browser: ok ignorare
        });

        // STEP 2 — verifica
        const verify = await fetch('/cart.js?_t=' + Date.now(), {
          credentials: 'same-origin',
        });
        const cartData = await verify.json();

        // Shopify ritorna cart.discount_codes: [{ code, amount, type }]
        // Se il discount è stato accettato, lo troviamo qui.
        if (Array.isArray(cartData.discount_codes)) {
          appliedSilently = cartData.discount_codes.some(function(d) {
            return d.code === code;
          });
        }

        if (appliedSilently) {
          _ss(flagKey, '1');
          _log('cart: discount applied silently, verified');

          // v1.2: tracking GA4 in-process
          _dispatchTracking(CFG.ga4.events.discountApplied, {
            fs_discount_code:   code,
            fs_discount_method: 'silent_fetch',
            fs_visitor_type:    SkonFS.id.getVisitorType(),
          });

          // DOM dispatch (compatibilità ascoltatori esterni)
          document.dispatchEvent(new CustomEvent('skon-fs:discount-applied', {
            detail: {
              code:         code,
              method:       'silent_fetch',
              group:        SkonFS.ab.getGroup(),
              visitor_type: SkonFS.id.getVisitorType()
            }
          }));
          // SKÖN custom (maggio 2026) — Forza refresh subito dopo apply
          // discount riuscito. Senza questo, _lastSubtotal/_lastCart restano
          // stale (Shopify Ajax /discount/CODE non emette eventi DOM), e
          // la progress bar + widget cross-sell non si aggiornano fino
          // al prossimo evento utile (apertura drawer, ecc.).
          SkonFS.cart.refresh();
          return;
        }

      } catch (e) {
        _log('cart: silent fetch failed', e);
      }

      // STEP 3 — fallback: arma il redirect al prossimo click utile.
      // NON facciamo redirect immediato per non spaccare l'esperienza in corso.
      // Lo facciamo al prossimo click su qualsiasi link interno o pulsante checkout.
      _log('cart: silent fetch did not apply discount, arming redirect fallback');
      this._armRedirectFallback(code);
    },

    /**
     * Arma un redirect a /discount/CODE?redirect=URL al prossimo evento
     * di navigazione utile (cart open, click su link interno).
     * Il redirect è invisibile come tempistica e Shopify lo gestisce nativamente.
     */
    _armRedirectFallback: function(code) {
      const flagKey = 'skon_fs_applied_' + code;
      const armedKey = 'skon_fs_redirect_armed_' + code;

      // Già armato → non riarmiamo
      if (_ss(armedKey) === '1') return;
      _ss(armedKey, '1');

      const performRedirect = function() {
        if (_ss(flagKey) === '1') return; // nel frattempo applicato
        const currentUrl = window.location.pathname + window.location.search;
        const target = '/discount/' + encodeURIComponent(code) +
                       '?redirect=' + encodeURIComponent(currentUrl);
        _log('cart: performing redirect fallback to', target);
        _ss(flagKey, '1');
        window.location.href = target;
      };

      // Trigger 1: apertura cart drawer (è il momento ideale, l'utente sta per checkout)
      const drawerListener = function(e) {
        if (e.target && e.target.tagName &&
            e.target.tagName.toLowerCase() === 'cart-drawer-component') {
          document.removeEventListener('dialog:open', drawerListener);
          performRedirect();
        }
      };
      document.addEventListener('dialog:open', drawerListener);

      // Trigger 2: click su pulsante "checkout" se l'utente lo preme prima
      const checkoutListener = function(e) {
        const target = e.target.closest('[name="checkout"], [data-checkout], a[href*="/checkout"]');
        if (target) {
          document.removeEventListener('click', checkoutListener);
          // In questo caso lasciamo l'evento naturale, ma prima passiamo da /discount
          e.preventDefault();
          performRedirect();
        }
      };
      document.addEventListener('click', checkoutListener);
    },

    /**
     * Scrive sul cart Shopify gli attributi di provenienza/segmentazione
     * del visitatore (tipo cliente, gruppo A/B, codice sconto applicato).
     *
     * Questi attributi vengono trasferiti automaticamente sull'ordine come
     * "Additional details" (note_attributes via API), accessibili sia da
     * Admin Shopify sia da Shopify Flow per automazioni come tagging
     * ordine, segmentazione, reportistica.
     *
     * Strategia idempotente: prima di scrivere confronta gli attributi
     * desiderati con quelli già presenti sul cart e fa la POST solo se
     * c'è almeno un valore da aggiornare. In questo modo evita chiamate
     * di rete inutili ad ogni cart update (vengono chiamati a frequenza
     * elevata in alcuni eventi del tema).
     *
     * Il flag di sessione 'skon_fs_attrs_written' protegge da chiamate
     * duplicate quando il subtotale è 0 (cart vuoto) e quindi non c'è
     * un cart da arricchire.
     */
    setCartAttributes: async function() {
      // Toggle dal config
      if (!CFG.orderAttributes || CFG.orderAttributes.enabled === false) return;

      const keys = (CFG.orderAttributes && CFG.orderAttributes.keys) || {};
      if (!keys.visitorType || !keys.group) {
        _log('cart: orderAttributes.keys not configured, skip');
        return;
      }

      // Costruisci il payload desiderato in base allo stato corrente del modulo
      const visitor = SkonFS.id.getVisitorType();
      const group   = SkonFS.ab.getGroup();
      const desired = {};
      desired[keys.visitorType] = visitor;
      desired[keys.group]       = group;

      // Codice sconto: solo se gruppo B (A non lo applica)
      if (keys.discountCode) {
        desired[keys.discountCode] = (group === 'B') ? CFG.discountCode : '';
      }

      // Verifica che ci sia almeno un valore diverso da quello già presente
      // sul cart, altrimenti skip per evitare POST inutili.
      try {
        const cartRes = await fetch('/cart.js?_t=' + Date.now(), {
          credentials: 'same-origin',
        });
        const cartData = await cartRes.json();
        const existing = cartData.attributes || {};

        let needsUpdate = false;
        for (const k in desired) {
          if (existing[k] !== desired[k]) { needsUpdate = true; break; }
        }
        if (!needsUpdate) {
          _log('cart: attributes already up-to-date, skip');
          return;
        }

        // Scrivi gli attributi
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: desired }),
        });
        _log('cart: attributes written', desired);
        // SKÖN custom (maggio 2026) — Refresh dopo set attributes per
        // mantenere _lastCart aggiornato. Anche se il subtotale non
        // cambia (gli attributes non lo modificano), altre routine
        // potrebbero leggere _lastCart subito dopo questa chiamata.
        SkonFS.cart.refresh();
      } catch (e) {
        _log('cart: setCartAttributes failed', e);
      }
    },
  };


  // ──────────────────────────────────────────────────────────────────
  // SkonFS.ui — Rendering progress bar + integrazione cart drawer
  // ──────────────────────────────────────────────────────────────────

  SkonFS.ui = {

    /**
     * SKÖN custom (maggio 2026) — Curva di calcolo della barra
     * free-shipping. Trasforma il pct lineare (0-100) in pct visivo
     * con curva √: cart appena iniziato dà già una sensazione di
     * progresso significativo (10% reale → ~32% mostrato), riducendo
     * l'effetto "barra impossibile". Asintoto a 100% reale = 100%
     * mostrato.
     *
     * Il messaggio testuale del gap residuo resta SEMPRE lineare e
     * veritiero ("Aggiungi €X"), così la promessa numerica al cliente
     * è onesta. Solo la rappresentazione grafica è ammorbidita.
     */
    _easeProgress: function(linearPct) {
      if (linearPct <= 0) return 0;
      if (linearPct >= 100) return 100;
      return Math.sqrt(linearPct / 100) * 100;
    },

    /**
     * SKÖN custom (maggio 2026) — REFACTOR ARCHITETTURALE.
     *
     * Costruisce LO SCHELETRO DOM della progress bar UNA SOLA VOLTA,
     * con tutti i nodi (banner promo NC, messaggio testuale, track
     * con fill e marker) ma senza valori — i valori vengono iniettati
     * dopo via _updateProgressShell.
     *
     * Razionale: prima del refactor, ogni cart change faceva
     * `placeholder.innerHTML = nuovoHtml`, distruggendo i nodi DOM
     * esistenti e ricreandoli da zero. Conseguenze:
     *   1) flicker visibile (il placeholder restava vuoto per ~50-150ms
     *      tra distruzione e ricostruzione)
     *   2) la transition CSS sul width del fill non animava (un
     *      elemento "appena nato" non ha valore precedente da cui
     *      animare)
     *   3) ogni mount sovrapposto = nuovo flicker
     *
     * Adesso lo scheletro è creato 1 volta. Ad ogni cart change,
     * _updateProgressShell muta solo le proprietà che cambiano
     * (data-*, classList, textContent, style.width). Niente
     * distruzione di nodi → niente flicker → la transition CSS sul
     * width del fill animatura naturalmente da valore precedente a
     * nuovo.
     */
    _buildProgressShell: function() {
      // Costruiamo via stringa una volta sola, poi parsiamo. È più
      // leggibile dell'API DOM imperativa per HTML statico, e una
      // volta inserito nessuno tocca più la struttura (solo i
      // contenuti via _updateProgressShell).
      const html = [
        '<div class="skon-fs-progress" data-skon-fs-shell="1">',
          '<div class="skon-fs-progress-promo" hidden>',
            '<span class="skon-fs-progress-promo-text">Per il tuo primo ordine arriva a </span>',
            '<span class="skon-fs-progress-promo-target">29€</span>',
            '<span class="skon-fs-progress-promo-original">49€</span>',
            '<span class="skon-fs-progress-promo-text"> e non paghi la spedizione!</span>',
          '</div>',
          '<div class="skon-fs-progress-text">',
            '<span class="skon-fs-progress-icon" hidden>✓</span>',
            '<span class="skon-fs-progress-message"></span>',
          '</div>',
          '<div class="skon-fs-progress-track">',
            '<div class="skon-fs-progress-fill" style="width:0%"></div>',
            '<span class="skon-fs-progress-track-marker">🚚 Gratis</span>',
          '</div>',
        '</div>'
      ].join('');

      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.firstElementChild;
    },

    /**
     * SKÖN custom (maggio 2026) — Mutazione dello scheletro esistente
     * con i dati del nuovo stato. NESSUN innerHTML qui dentro: solo
     * cambi di textContent, classList, dataset, style.width.
     *
     * Garantisce zero flicker e animazione fluida del fill.
     *
     * Input: state object dal SkonFS.bus 'skon-fs:state-changed'
     * (vedi SkonFS.cart._buildState).
     */
    _updateProgressShell: function(shell, state) {
      if (!shell) return;

      const subtotal     = state.subtotal_cents;
      const threshold    = state.threshold_cents;
      const gap          = state.gap_cents;
      const achieved     = state.achieved;
      const pctLinear    = state.pct_linear;
      const isBelowHalfway = state.is_below_halfway;
      const trackVisible = state.track_visible;
      const group        = state.group;
      const visitor      = state.visitor_type;

      const pct = this._easeProgress(pctLinear);

      // 1. Data attributes sul wrapper (CSS gestisce visibilità,
      //    colori, animazioni in base a questi).
      shell.dataset.achieved = achieved ? '1' : '0';
      shell.dataset.group = group;
      shell.dataset.progressVisible = trackVisible ? '1' : '0';

      // 2. Banner promo NC (solo gruppo B + NC + non achieved)
      const showFirstOrderLabel = (group === 'B' && visitor === 'NC' && !achieved);
      const promo = shell.querySelector('.skon-fs-progress-promo');
      if (promo) {
        if (showFirstOrderLabel) {
          promo.removeAttribute('hidden');
        } else {
          promo.setAttribute('hidden', '');
        }
      }

      // 3. Messaggio testuale condizionale.
      //
      // Logica:
      // - achieved (≥100%):                          CFG.copy.achieved (celebrativo)
      // - track visibile + non achieved:             CFG.copy.progress (economico, con gap)
      // - sotto 50% senza track + banner NC sopra:   CFG.copy.progressBelowThresholdNcB (valoriale, no soglia)
      // - sotto 50% senza track senza banner:        CFG.copy.progressBelowThreshold (valoriale + soglia)
      //
      // SKÖN custom (maggio 2026) — Quando la track è visibile (per
      // soglia raggiunta o per stickyness di sessione), il messaggio
      // DEVE riferirsi al gap economico concreto ("Aggiungi X€ per la
      // spedizione gratuita"). Mostrare il messaggio valoriale CO₂
      // mentre la barra è visibile crea incoerenza (es. barra al 70%
      // visivo + messaggio "Da 49€ la spedizione è gratis"): il
      // visitatore non capisce a che punto è.
      const thresholdShort = _formatEUR(threshold).replace(',00', '').replace(' €', '€');
      let message;
      if (achieved) {
        message = CFG.copy.achieved;
      } else if (trackVisible) {
        // Track visibile + non achieved: messaggio economico con gap
        message = _interpolate(CFG.copy.progress, { gap: _formatEUR(gap) });
      } else if (isBelowHalfway) {
        // Track NON visibile e sotto-50%: messaggio valoriale (NCB se
        // banner NC sopra, standard altrimenti)
        const valueDrivenCopy = showFirstOrderLabel && CFG.copy.progressBelowThresholdNcB
          ? CFG.copy.progressBelowThresholdNcB
          : CFG.copy.progressBelowThreshold;
        if (valueDrivenCopy) {
          message = _interpolate(valueDrivenCopy, {
            gap:       _formatEUR(gap),
            threshold: thresholdShort,
          });
        } else {
          message = _interpolate(CFG.copy.progress, { gap: _formatEUR(gap) });
        }
      } else {
        message = _interpolate(CFG.copy.progress, { gap: _formatEUR(gap) });
      }

      // Il messaggio può contenere HTML (<strong>, <br>) — innerHTML è
      // sicuro qui perché il copy proviene da CFG (config statica
      // controllata da noi, non input utente: no XSS risk).
      const messageEl = shell.querySelector('.skon-fs-progress-message');
      if (messageEl) messageEl.innerHTML = message;

      // 4. Icona ✓ del messaggio: visibile solo a stato achieved
      const iconEl = shell.querySelector('.skon-fs-progress-icon');
      if (iconEl) {
        if (achieved) {
          iconEl.removeAttribute('hidden');
        } else {
          iconEl.setAttribute('hidden', '');
        }
      }

      // 5. Marker della track: pill "🚚 Gratis" sotto-soglia, "✅" achieved
      const markerEl = shell.querySelector('.skon-fs-progress-track-marker');
      if (markerEl) {
        if (achieved) {
          markerEl.classList.add('skon-fs-progress-track-marker--achieved');
          markerEl.textContent = '✅';
        } else {
          markerEl.classList.remove('skon-fs-progress-track-marker--achieved');
          markerEl.textContent = '🚚 Gratis';
        }
      }

      // 6. Fill: setta il width target. Se questo è il PRIMO unlock
      //    della sessione, l'animazione "from 0" è gestita più sotto
      //    via setTimeout drawer-aware. Altrimenti la transition CSS
      //    sul width fa il movimento da valore precedente al nuovo
      //    (questa è la chiave del NO-FLICKER: lo stesso nodo DOM
      //    persiste tra cart change, quindi il browser conosce il
      //    valore precedente del width e anima la transizione).
      const fillEl = shell.querySelector('.skon-fs-progress-fill');
      const targetWidth = pct.toFixed(1) + '%';

      const wasUnlocked = _ss('skon_fs_progress_unlocked_session') === '1';
      const firstTimeUnlock = trackVisible && !wasUnlocked;

      if (firstTimeUnlock) {
        _ss('skon_fs_progress_unlocked_session', '1');
        _log('progress track: first unlock, animating from 0');

        // Animazione drawer-aware: aspettiamo che il drawer sia
        // aperto (per essere sicuri che l'utente la veda) + 250ms
        // di pausa per non sovrapporsi allo slide-in del drawer.
        if (fillEl) {
          fillEl.style.width = '0%';
          // Forza reflow
          // eslint-disable-next-line no-unused-expressions
          fillEl.offsetWidth;

          const startAnimation = function() {
            // rAF doppio garantisce che il browser registri il
            // width=0% prima del cambio al target (necessario per
            // far partire la transition CSS).
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                fillEl.style.width = targetWidth;
              });
            });
          };

          const drawerEl = document.querySelector('cart-drawer-component dialog');
          const drawerOpen = drawerEl && drawerEl.hasAttribute('open');
          if (drawerOpen) {
            setTimeout(startAnimation, 250);
          } else if (drawerEl) {
            // Polling per attesa apertura drawer (cap 2s)
            let attempts = 0;
            const maxAttempts = 20;
            const checkInterval = setInterval(function() {
              attempts++;
              if (drawerEl.hasAttribute('open')) {
                clearInterval(checkInterval);
                setTimeout(startAnimation, 250);
              } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                startAnimation();
              }
            }, 100);
          } else {
            startAnimation();
          }
        }
      } else {
        // Update normale: setta il width, la transition CSS
        // anima da valore precedente al nuovo (smooth, no flicker).
        if (fillEl) fillEl.style.width = targetWidth;
      }

      // 7. Body classes per integrazione cart-summary.liquid
      //    (toggle riga "Spedizione" tra valore stimato e GRATIS)
      document.body.classList.add('skon-fs-active');
      if (achieved) {
        document.body.classList.add('skon-fs-achieved');
      } else {
        document.body.classList.remove('skon-fs-achieved');
      }

      // 8. Tracking event "threshold reached" — dispatchato la prima
      //    volta che il visitatore raggiunge la soglia in questa sessione.
      //    v1.2: chiamata diretta in-process al tracking GA4. Il CustomEvent
      //    DOM viene comunque dispatchato per compatibilità ascoltatori esterni.
      if (subtotal >= threshold) {
        if (_ss('skon_fs_threshold_reached_session') !== '1') {
          _ss('skon_fs_threshold_reached_session', '1');
          _log('threshold reached: subtotal', subtotal, '≥ threshold', threshold);

          // v1.2: tracking GA4 in-process. Passiamo group/threshold
          // esplicitamente: sono già nello scope, evitiamo getGroup() ridondante.
          _dispatchTracking(CFG.ga4.events.thresholdReached, {
            fs_subtotal_cents: subtotal,
            fs_subtotal_eur:   String((subtotal / 100).toFixed(2)),
            fs_visitor_type:   visitor,
          }, { group: group, threshold: threshold });

          // DOM dispatch (compatibilità ascoltatori esterni)
          document.dispatchEvent(new CustomEvent('skon-fs:threshold-reached', {
            detail: {
              subtotal_cents: subtotal,
              threshold_cents: threshold,
              group: group,
              visitor_type: visitor
            }
          }));
        }
      }
    },

    /**
     * SKÖN custom (maggio 2026) — LEGACY API.
     *
     * renderProgressBar è mantenuta per backward-compatibility con
     * eventuali consumer esterni. Costruisce HTML completo a partire
     * da subtotal/threshold (e legge group/visitor da SkonFS.ab e .id).
     *
     * NOTA: il modulo internamente NON usa più questa funzione per
     * i mount. Usa _buildProgressShell + _updateProgressShell. Questa
     * funzione resta per chi (es. test esterni, debugging in console)
     * vuole un dump statico dell'HTML rappresentativo dello stato.
     */
    renderProgressBar: function(subtotalCents, thresholdCents) {
      const shell = this._buildProgressShell();
      const fakeState = SkonFS.cart._buildState
        ? Object.assign({}, SkonFS.cart._buildState(), {
            subtotal_cents: subtotalCents,
            threshold_cents: thresholdCents,
          })
        : null;
      if (fakeState) {
        // Ricalcola i derivati con i nuovi subtotal/threshold
        fakeState.gap_cents = Math.max(0, thresholdCents - subtotalCents);
        fakeState.achieved = fakeState.gap_cents === 0;
        fakeState.pct_linear = thresholdCents > 0
          ? Math.min(100, (subtotalCents / thresholdCents) * 100)
          : 0;
        const gapTriggerPct = (CFG.widgetModes && CFG.widgetModes.gapTriggerPct) || 0.50;
        fakeState.is_below_halfway = !fakeState.achieved && (fakeState.pct_linear < gapTriggerPct * 100);
        fakeState.track_visible = fakeState.achieved || (fakeState.pct_linear >= gapTriggerPct * 100);
        this._updateProgressShell(shell, fakeState);
      }
      return shell.outerHTML;
    },

    /**
     * Mount/aggiornamento della progress bar nei placeholder
     * [data-skon-fs-progress] del cart drawer.
     *
     * SKÖN custom (maggio 2026) — REFACTOR.
     * Strategia: ENSURE-AND-UPDATE.
     *   1) Se il placeholder è vuoto (primo render o tema l'ha svuotato),
     *      costruisce lo shell DOM una sola volta e lo inserisce.
     *   2) Sempre, applica _updateProgressShell con lo state corrente.
     *
     * Niente più innerHTML su update. Il primo mount è l'unica volta
     * in cui il DOM viene creato; tutti i mount successivi mutano
     * proprietà sui nodi esistenti. Zero flicker.
     */
    mountProgressBarFast: function() {
      const subtotal = SkonFS.cart._lastSubtotal;
      if (subtotal === null) {
        _log('progress bar mount skipped: subtotal still loading');
        return;
      }

      const state = SkonFS.cart._buildState();
      const placeholders = document.querySelectorAll('[data-skon-fs-progress]');

      const self = this;
      placeholders.forEach(function(el) {
        let shell = el.querySelector('[data-skon-fs-shell="1"]');
        if (!shell) {
          // Primo render o shell distrutto: costruisci e inserisci
          shell = self._buildProgressShell();
          el.appendChild(shell);
        }
        self._updateProgressShell(shell, state);
      });

      _log('progress bar updated: subtotal', subtotal, '/ threshold', state.threshold_cents);
    },

    /**
     * Versione async che fa refresh + mount.
     * Backward-compatibility con il bootstrap e con consumer esterni.
     */
    mountProgressBar: async function() {
      await SkonFS.cart.refresh();
      // Nota: cart.refresh() ora dispatcha 'skon-fs:state-changed',
      // che è ascoltato dal bootstrap → chiama mountProgressBarFast.
      // Però chiamiamo anche qui esplicitamente per garantire un
      // mount immediato anche se il listener non è ancora attivo
      // (race condition durante boot).
      this.mountProgressBarFast();
    },
  };


  // ──────────────────────────────────────────────────────────────────
  // BOOTSTRAP — orchestrazione
  // ──────────────────────────────────────────────────────────────────

  function bootstrap() {

    // Espone SUBITO il namespace per debug.
    // Anche quando il modulo non si attiva, vogliamo poter ispezionare
    // SkonFS.id.shouldActivate(), SkonFS.ab.getGroup(), ecc. in console.
    window.SkonFS = SkonFS;
    SkonFS._cfg = CFG;

    // v1.4.1 — Dispatch evento skon_fs_visitor_identified.
    // Eseguito PRIMA di tutto il resto (anche prima di shouldActivate),
    // per misurare quanti visitatori il modulo VEDE e come li classifica.
    // Confronto ex-post con shopify audience=new sessions → identifica
    // dove sparisce il traffico nella pipeline.
    // Dispatch diretto a gtag/dataLayer (NON via _dispatchTracking)
    // perché _dispatchTracking ha guard su shouldActivate e qui invece
    // vogliamo loggare ANCHE i visitatori per cui il modulo è inattivo.
    // FIX v1.4.1: guard armato SOLO dopo dispatch riuscito. Retry
    // polling 100ms fino a 10s se gtag/dataLayer non pronti al bootstrap.
    (function dispatchVisitorIdentified() {
      const guardKey = 'skon_fs_visitor_identified_session';
      try {
        if (sessionStorage.getItem(guardKey) === '1') return;
      } catch(e) { return; }

      // v1.4.2 — Lettura audience: priorità URL param, fallback sessionStorage.
      // L'URL param è disponibile SUBITO al bootstrap, mentre nc-experience.js
      // (che scrive skon_nc_audience_raw) è caricato async e potrebbe non aver
      // ancora scritto al momento del dispatch.
      let _ss_audience = '';
      try {
        const _url_audience = new URLSearchParams(window.location.search).get('audience');
        if (_url_audience) {
          _ss_audience = _url_audience;
        } else {
          _ss_audience = sessionStorage.getItem('skon_nc_audience_raw') || '';
        }
      } catch(e) {}
      const _ident_visitor = (SkonFS.id && SkonFS.id.getVisitorType)
        ? SkonFS.id.getVisitorType() : 'unknown';
      const _ident_activate = (SkonFS.id && SkonFS.id.shouldActivate)
        ? !!SkonFS.id.shouldActivate() : false;
      const _ident_release = (CFG.release && CFG.release.mode) || 'unknown';
      const _ident_params = {
        fs_visitor_type:     _ident_visitor,
        fs_landing_audience: _ss_audience,
        fs_should_activate:  _ident_activate ? 'yes' : 'no',
        fs_release_mode:     _ident_release,
      };

      function tryDispatch() {
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'skon_fs_visitor_identified', _ident_params);
            try { sessionStorage.setItem(guardKey, '1'); } catch(e) {}
            return true;
          }
          if (window.dataLayer && Array.isArray(window.dataLayer)) {
            window.dataLayer.push(Object.assign({event: 'skon_fs_visitor_identified'}, _ident_params));
            try { sessionStorage.setItem(guardKey, '1'); } catch(e) {}
            return true;
          }
        } catch(e) {}
        return false;
      }

      if (tryDispatch()) return;

      let attempts = 0;
      const maxAttempts = 100;
      const interval = setInterval(function() {
        attempts++;
        if (tryDispatch() || attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 100);
    })();

    // Step 1 — verifica audience
    if (!SkonFS.id.shouldActivate()) {
      _log('bootstrap: visitor not in target audience, exit');
      console.info('[skon-fs] module loaded but NOT activated. ' +
        'Check: release.mode=' + (CFG.release && CFG.release.mode) +
        ', unlockParam=' + (_getParam(CFG.release && CFG.release.unlockParam)) +
        ', visitorType=' + SkonFS.id.getVisitorType());
      return;
    }

    // v1.2 — Espone API tracking come compat per consumer esterni.
    // ATTENZIONE: esposta SOLO dopo shouldActivate(), per replicare il
    // comportamento di skon-fs-tracking.js v1.0 (che aveva una guard
    // equivalente prima di esporre SkonFS.tracking).
    // I 4 punti interni del modulo che chiamano _dispatchTracking sono
    // tutti DENTRO bootstrap() o in handler registrati DOPO questo punto,
    // quindi anche loro sono protetti dallo stesso early return.
    SkonFS.tracking = {
      dispatch: _dispatchTracking,
      // Esposto per QA/debug
      _getPendingQueue: function() { return _trkPendingEvents.slice(); },
      _getRecentSignatures: function() {
        const out = {};
        _trkRecentSignatures.forEach(function(ts, sig) { out[sig] = ts; });
        return out;
      }
    };

    _log('bootstrap: starting for visitor type =', SkonFS.id.getVisitorType());

    // Step 2 — assegna gruppo A/B (e scrive cookie se prima volta)
    const group = SkonFS.ab.getGroup();
    _log('bootstrap: assigned group =', group);

    // Step 3 — se NC + gruppo B, applica discount in funzione del trigger.
    //
    // DOUBLE CHECK: il modulo è ora universale (attivo anche per RC e
    // unknown), quindi controlliamo esplicitamente che il visitatore sia
    // NC prima di applicare il coupon. In pratica `getGroup()` per
    // RC/unknown ritorna sempre 'A' quindi questo branch non sarebbe
    // mai raggiunto da non-NC, ma il check esplicito è una salvaguardia
    // contro futuri refactoring (e contro l'uso di ?skon_fs_force=B
    // su sessioni di test in cui il visitatore non è NC).
    const visitor = SkonFS.id.getVisitorType();
    if (group === 'B' && visitor === 'NC') {
      const trigger = CFG.applyTrigger;

      if (trigger === 'on_first_add') {
        // SKÖN custom (maggio 2026) — Auto-apply coupon SK-FS29 al primo
        // cart event. Ascoltiamo TUTTI i nomi event utilizzati dai temi
        // per cart add/update perché Shopify/Dawn non standardizzano:
        //   - 'cart:add' (Dawn convention)
        //   - 'cart:update' (questo tema custom — confermato via test live)
        //   - 'cart-update' (alcune varianti Dawn)
        //
        // applyDiscount() ha già un guard interno via sessionStorage flag
        // (riga 577), quindi anche se più listener vengono triggerati
        // viene applicato una volta sola. Niente { once: true } sul
        // listener (lasciamo che il guard gestisca l'idempotenza, così
        // se il primo evento fallisce silenziosamente abbiamo retry sul
        // successivo).
        const applyOnEvent = function() {
          // Apply solo se il cart ha effettivamente almeno un item
          // (subtotal > 0). Necessario per cart:update che viene anche
          // dispatchato in altri scenari (es. svuotamento cart).
          if ((SkonFS.cart.getSubtotal() || 0) > 0) {
            SkonFS.cart.applyDiscount(CFG.discountCode);
          }
        };
        document.addEventListener('cart:add', applyOnEvent);
        document.addEventListener('cart:update', applyOnEvent);
        document.addEventListener('cart-update', applyOnEvent);
      }

      if (trigger === 'on_cart_open') {
        // Applica all'apertura del drawer
        document.addEventListener('dialog:open', function(e) {
          if (e.target && e.target.tagName &&
              e.target.tagName.toLowerCase() === 'cart-drawer-component') {
            SkonFS.cart.applyDiscount(CFG.discountCode);
          }
        });
      }
    }

    // ────────────────────────────────────────────────────────────────
    // CHECKOUT INITIATED — tracking + (solo gruppo B) redirect via /discount
    //
    // Listener installato per TUTTI i visitatori (NC, RC, unknown) e tutti
    // i gruppi (A, B, default) perché il tracking checkout_initiated serve
    // a misurare il funnel intero, non solo lo split di trattamento.
    //
    // Dentro al listener, due comportamenti distinti:
    //
    // 1) Tracking sempre: emette skon-fs:checkout-initiated con group +
    //    subtotal + achieved. Il tracking layer lo pusha su dataLayer.
    //
    // 2) Discount redirect SOLO per NC gruppo B sopra-soglia: per persistere
    //    il discount SK-FS29 attraverso la transizione cart→checkout. Negli
    //    altri casi non c'è discount da persistere e il flusso resta
    //    invariato (form submit naturale verso /checkout).
    // ────────────────────────────────────────────────────────────────
    const interceptCheckoutClick = function(e) {
      const button = e.target.closest('[name="checkout"]');
      if (!button) return;

      const subtotal  = SkonFS.cart._lastSubtotal || 0;
      const threshold = SkonFS.ab.getThreshold();
      const visitor   = SkonFS.id.getVisitorType();
      const grp       = SkonFS.ab.getGroup();
      const achieved  = subtotal >= threshold;

      // Tracking event "checkout initiated" — sempre, indipendente dal gruppo
      // v1.2: chiamata diretta in-process al tracking GA4. One-time guard
      // per evitare doppi fire (utente che torna indietro dal checkout).
      // Guard spostato qui da skon-fs-tracking.js v1.0/1.1.
      if (_ss('skon_fs_ga4_checkout_fired') !== '1') {
        _ss('skon_fs_ga4_checkout_fired', '1');

        _dispatchTracking(CFG.ga4.events.checkoutInitiated, {
          fs_subtotal_cents: subtotal,
          fs_subtotal_eur:   String((subtotal / 100).toFixed(2)),
          fs_achieved:       achieved ? 'yes' : 'no',
          fs_visitor_type:   visitor,
        }, { group: grp, threshold: threshold });
      }

      // DOM dispatch (compatibilità ascoltatori esterni, sempre dispatched)
      document.dispatchEvent(new CustomEvent('skon-fs:checkout-initiated', {
        detail: {
          subtotal_cents: subtotal,
          threshold_cents: threshold,
          group: grp,
          visitor_type: visitor,
          achieved: achieved
        }
      }));

      // Discount redirect: solo NC gruppo B sopra-soglia (vedi commento sopra)
      if (visitor !== 'NC' || grp !== 'B') return;
      if (subtotal < threshold) {
        _log('checkout: below threshold, skipping discount redirect');
        return;
      }

      // Sopra soglia + NC + B: intercettiamo e redirezionamo via /discount/CODE
      e.preventDefault();
      e.stopPropagation();

      const code = CFG.discountCode;
      const target = '/discount/' + encodeURIComponent(code) +
                     '?redirect=' + encodeURIComponent('/checkout');
      _log('checkout: redirecting via', target, 'to persist discount across checkout transition');
      window.location.href = target;
    };

    // Capture phase (true) per intercettare PRIMA che il form submetta il browser
    document.addEventListener('click', interceptCheckoutClick, true);

    // Step 4 — mount progress bar al primo render utile e ad ogni cart update

    // SKÖN custom (maggio 2026) — REFACTOR ARCHITETTURALE.
    //
    // Il modulo UI ascolta 'skon-fs:state-changed' (emesso da
    // SkonFS.cart.refresh) e fa mount/update via _updateProgressShell.
    // Questo è IL SOLO punto in cui mountProgressBarFast viene chiamato
    // sul flusso normale (cart events → scheduleRefresh → refresh →
    // emit → questo listener).
    //
    // Eccezione: il MutationObserver safety-net chiama mountProgressBarFast
    // direttamente quando il tema svuota il placeholder, bypassando
    // refresh perché la cache è già fresca.
    SkonFS.bus.on('skon-fs:state-changed', function(e) {
      SkonFS.ui.mountProgressBarFast();

      // SKÖN custom (maggio 2026) — Fix bug "cart-drawer--empty stale class".
      //
      // BUG: il Liquid `cart-drawer.liquid` setta la classe
      // `cart-drawer--empty` sul <dialog> al render iniziale solo
      // quando `cart.empty?` (riga 28 del Liquid). Quando il visitatore
      // aggiunge un prodotto MENTRE il drawer è già aperto (es. dal
      // widget bestseller a cart vuoto), il tema ricarica via Section
      // Rendering API soltanto il contenuto interno (cart-drawer__inner),
      // ma NON tocca il <dialog> parent: la classe `cart-drawer--empty`
      // resta lì anche se il cart non è più vuoto, applicando agli
      // elementi popolati gli stili pensati per lo stato vuoto
      // (text-align: center sui contenuti) → layout disallineato.
      //
      // FIX: ad ogni cart state change, sincronizziamo la classe del
      // dialog con lo stato reale: presente se subtotal=0, assente
      // se subtotal>0. Speculaarmente per coerenza (anche se il caso
      // "popolato → vuoto" raramente accade senza chiusura/riapertura
      // del drawer).
      const state = (e && e.detail) || (SkonFS.cart._buildState && SkonFS.cart._buildState());
      if (!state) return;
      const dialog = document.querySelector('cart-drawer-component dialog');
      if (!dialog) return;
      if (state.subtotal_cents > 0) {
        dialog.classList.remove('cart-drawer--empty');
      } else {
        dialog.classList.add('cart-drawer--empty');
      }
    });

    // Render iniziale: scatena il refresh dal /cart.js, che a sua volta
    // emetterà skon-fs:state-changed e attiverà il listener qui sopra.
    SkonFS.cart.refresh();

    // Scrivi gli attributi sul cart appena il bootstrap è pronto.
    // Se il cart è vuoto la chiamata non fa danni: gli attributi vengono
    // creati comunque e attendono il primo prodotto aggiunto.
    SkonFS.cart.setCartAttributes();

    // Re-fetch (e re-mount) ad ogni cart update.
    // Eventi candidati: 'cart:update', 'cart:add', 'discount:update' (Dawn convention)
    // più nomi internamente usati dal tema.
    //
    // SKÖN custom (maggio 2026) — Tutti questi eventi vanno in
    // scheduleRefresh (debounced) per evitare cicli di mount multipli.
    // Vedi commento esteso su SkonFS.cart.scheduleRefresh.
    const cartEvents = ['cart:update', 'cart:add', 'discount:update', 'cart-update'];
    cartEvents.forEach(function(evName) {
      document.addEventListener(evName, function() {
        SkonFS.cart.scheduleRefresh();
        // setCartAttributes è idempotente e fa POST solo se cambia.
        // Lo lasciamo "diretto" perché non genera mount né flicker.
        SkonFS.cart.setCartAttributes();
      });
    });

    // Re-mount ad ogni apertura del cart drawer (refresh fresco al click)
    document.addEventListener('dialog:open', function(e) {
      if (e.target && e.target.tagName &&
          e.target.tagName.toLowerCase() === 'cart-drawer-component') {
        SkonFS.cart.refresh();
      }
    });

    // MutationObserver come safety net: se il tema morfa la section cart
    // e il nostro placeholder si svuota, lo ripopoliamo IMMEDIATAMENTE.
    //
    // SKÖN custom (maggio 2026) — Re-mount diretto, senza scheduleRefresh.
    //
    // Quando il tema svuota il placeholder durante un cart update, la
    // cache di SkonFS.cart._lastSubtotal è già fresca (è stata appena
    // aggiornata dal cart event 80-150ms prima). Non serve fare un altro
    // fetch /cart.js: chiamiamo direttamente le versioni Fast del mount,
    // che leggono dalla cache.
    //
    // Razionale: passare per scheduleRefresh aggiunge 100ms di debounce
    // + il fetch async + mount = 200-300ms di gap visibile tra "placeholder
    // vuoto" e "card ripopolate" = flicker. Re-mount diretto = ~5ms gap,
    // impercettibile.
    const observer = new MutationObserver(function() {
      if (SkonFS.cart._lastSubtotal === null) return; // Boot non ancora completo

      const placeholder = document.querySelector('[data-skon-fs-progress]');
      const sgPlaceholder = document.querySelector('[data-skon-fs-suggestions]');
      const progressEmpty = placeholder && placeholder.children.length === 0;
      const sgEmpty = sgPlaceholder && sgPlaceholder.children.length === 0;

      if (progressEmpty && SkonFS.ui && typeof SkonFS.ui.mountProgressBarFast === 'function') {
        SkonFS.ui.mountProgressBarFast();
      }
      if (sgEmpty && SkonFS.suggestions && typeof SkonFS.suggestions.mountWidgetFast === 'function') {
        SkonFS.suggestions.mountWidgetFast();
      }
    });

    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
      _log('bootstrap: MutationObserver attached to cart-drawer-component');
    }

    // v1.2 — Listener per evento esterno emesso da skon-fs-suggestions.js
    // (il widget cross-sell vive in un file separato). Questo è l'unico
    // listener DOM rimasto per il tracking GA4: gli altri 4 eventi sono
    // emessi DA questo file e usano chiamata diretta _dispatchTracking.
    //
    // v1.3 — Listener difensivo: accetta entrambe le convenzioni del payload
    // (snake_case dal v1.1+ di suggestions, camelCase dal v1.0). Se entrambe
    // sono assenti, defaulta a stringa/0. visitor_type ha fallback a
    // SkonFS.id.getVisitorType() perché il payload v1.0 non lo includeva.
    document.addEventListener('skon-fs:filler-added', function(e) {
      const detail = e.detail || {};

      // Lettura difensiva snake_case OR camelCase
      const handle    = detail.product_handle || detail.productHandle || '';
      const title     = detail.title          || '';
      const priceCnt  = (typeof detail.price_cents === 'number' ? detail.price_cents
                      : (typeof detail.priceCents  === 'number' ? detail.priceCents
                      : 0));
      const varId     = detail.variant_id     || detail.variantId    || '';
      const subBefore = (typeof detail.subtotal_before_cents === 'number')
                        ? detail.subtotal_before_cents
                        : undefined;
      const visitor   = detail.visitor_type
                        || (SkonFS.id && SkonFS.id.getVisitorType ? SkonFS.id.getVisitorType() : '');

      _dispatchTracking(CFG.ga4.events.fillerAdded, {
        fs_filler_handle:    handle,
        fs_filler_title:     title,
        fs_filler_price_eur: String((priceCnt / 100).toFixed(2)),
        fs_filler_variant:   String(varId),
        fs_subtotal_before:  subBefore,
        fs_visitor_type:     visitor,
      });
    });

    // Step 5 — bootstrap completo
    _log('bootstrap: complete. window.SkonFS available for debug.');
  }


  // ──────────────────────────────────────────────────────────────────
  // ENTRY POINT
  // ──────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

})();